import React from 'react';
import { ChevronLeft, Newspaper, Zap, Globe2 } from 'lucide-react';

const AboutPage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-slate-950 dark:via-slate-950 dark:to-slate-950 flex justify-center py-8">
            <div className="w-full max-w-3xl px-4 lg:px-8">
                <button
                    onClick={() => window.location.hash = '/'}
                    className="inline-flex items-center text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 font-medium mb-8 transition-colors"
                >
                    <ChevronLeft size={18} className="mr-1" />
                    Back to Home
                </button>

                <article className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 border border-gray-200 dark:border-slate-800">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">About BrieflyCA</h1>

                    <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-slate-300 space-y-4">

                        <p>
                            <strong>BrieflyCA</strong> is a modern Canadian news platform designed for speed,
                            clarity, and convenience. Our mission is to deliver the most important stories
                            in clean, concise, 60-second summaries that fit your busy lifestyle.
                        </p>

                        <p>
                            We believe Canadians deserve quick, reliable updates without endless scrolling,
                            clutter, or overwhelming feeds. That's why BrieflyCA blends smart automation
                            with human-first editorial structure to bring you the news that matters — fast.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100 mt-8 mb-2">
                            What We Offer
                        </h2>

                        <div className="grid gap-6 md:grid-cols-3 mt-4">
                            <div className="flex flex-col items-center text-center">
                                <Zap className="w-10 h-10 text-red-500 mb-2" />
                                <h3 className="font-semibold text-gray-900 dark:text-white">Fast Summaries</h3>
                                <p className="text-sm text-gray-600 dark:text-slate-400">
                                    Get the news in under 60 seconds — clear, accurate, and up to date.
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center">
                                <Newspaper className="w-10 h-10 text-red-500 mb-2" />
                                <h3 className="font-semibold text-gray-900 dark:text-white">Clean Interface</h3>
                                <p className="text-sm text-gray-600 dark:text-slate-400">
                                    Swipe-based reading, clean UI, and smooth animations for an effortless experience.
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center">
                                <Globe2 className="w-10 h-10 text-red-500 mb-2" />
                                <h3 className="font-semibold text-gray-900 dark:text-white">Canada-Focused</h3>
                                <p className="text-sm text-gray-600 dark:text-slate-400">
                                    Built for Canadians, curating important local and national stories.
                                </p>
                            </div>
                        </div>

                        <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100 mt-10 mb-2">
                            Our Mission
                        </h2>
                        <p>
                            BrieflyCA aims to make Canadian news accessible and digestible for everyone.
                            We want to support responsible journalism by directing users to full news sources
                            while reducing the noise of traditional feeds.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100 mt-10 mb-2">
                            Independent & Transparent
                        </h2>
                        <p>
                            We are not affiliated with any news publisher, political group, organization,
                            or broadcaster. Our content is independently rewritten from publicly available news.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100 mt-10 mb-2">
                            Contact
                        </h2>
                        <p>
                            Have suggestions or want to collaborate? Email us anytime:
                            {" "}
                            <a href="mailto:info@askstudios.ca" className="text-red-600 dark:text-red-400 hover:underline">
                                info@askstudios.ca
                            </a>
                        </p>
                    </div>
                </article>
            </div>
        </div>
    );
};

export default AboutPage;
